/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Err_NameInputs */

const vi_cdo_err_name = /** @type {(inputs: Cdo_Err_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập họ tên người nhận`)
};

/**

* @param {Cdo_Err_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_err_name = /** @type {((inputs?: Cdo_Err_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Err_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_err_name(inputs)
});